module.exports = __webpack_public_path__ + "media/images/Sink Install with laser-cc941188.webp";